

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService, Core2Config, ApiVisa, ApiResponseModel } from '../shared';

// /core2/tnt/dm/applet/login-subject-links/determine-tenant-level-switch/tenant-admin-ep

@Injectable({
  providedIn: 'root'
})
export class DetermineTenantAdminOwnerService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet/login-subject-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet/login-subject-links';
    this.httpClient = http;
  }
  
  getPermission(apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path
    }
    const url = this.apiUrl + '/determine-tenant-level-switch/tenant-admin-ep';
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }
}

